import { ca } from '@cian/analytics';

export const trackIndexTransportShow = () => {
  ca('eventSite', {
    action: 'show_sopr',
    category: 'Index_transport',
    label: 'show_index_transport',
    name: 'oldevent',
    useLastProducts: true,
  });
};
